module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"pwa":{"newContent":{"message":"A new version of {appTitle} is available.","callToAction":"Update"}}},"es-MX":{"pwa":{"newContent":{"message":"Una nueva versión de {appTitle} está disponible.","callToAction":"Actualizar"}}}}')
  delete Component.options._Ctor
}
